import axios from "axios";
import {
  ALL_USER_COLLECTIONS,
  CHECKOUT,
  CREATE_COLLECTION,
  CREATE_NFT,
  LOGIN,
  REGISTER,
  UPDATE_USER,
  UPLOAD_IMAGE,
} from "./routes";

// get token from localStorage
const token = localStorage.getItem("authToken");

// IMAGE UPLOAD ---
export const uploadImage = async (formData) => {
  try {
    const response = await axios.post(UPLOAD_IMAGE, formData);
    return response;
  } catch (error) {
    return error.response;
  }
};

// REGISTER ---
export const register = async (payload) => {
  try {
    const config = {
      headers: {
        "content-type": "application/json",
      },
    };
    const response = await axios.post(REGISTER, payload, config);
    return response;
  } catch (error) {
    return error.response;
  }
};

// LOGIN ---
export const login = async (payload) => {
  try {
    const config = {
      headers: {
        "content-type": "application/json",
      },
    };
    const response = await axios.post(LOGIN, payload, config);
    // save token to localstorage
    localStorage.setItem("authToken", response.data.token);
    localStorage.setItem("user", JSON.stringify(response.data.user));
    return response;
  } catch (error) {
    return error.response;
  }
};

// UPDATE USER ---
export const updateUser = async (payload) => {
  try {
    const config = {
      headers: {
        "content-type": "application/json",
      },
    };
    const response = await axios.post(UPDATE_USER, payload, config);
    // save token to localstorage
    localStorage.setItem("user", JSON.stringify(response.data.data));

    setTimeout(() => {
      window.location.reload();
    }, 5000);
    return response;
  } catch (error) {
    return error.response;
  }
};

// CREATE COLLECTION
export const createCollection = async (payload) => {
  try {
    const config = {
      headers: {
        "content-type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axios.post(CREATE_COLLECTION, payload, config);
    return response;
  } catch (error) {
    return error.response;
  }
};

// GET ALL USER COLLECTIONS
export const getUserCollections = async (payload) => {
  try {
    const config = {
      headers: {
        "content-type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axios.post(ALL_USER_COLLECTIONS, payload, config);
    return response;
  } catch (error) {
    return error.response;
  }
};

// CREATE NFT
export const createNFT = async (payload) => {
  try {
    const config = {
      headers: {
        "content-type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axios.post(CREATE_NFT, payload, config);
    return response;
  } catch (error) {
    return error.response;
  }
};

// CHECKOUT
export const checkout = async (payload) => {
  try {
    const config = {
      headers: {
        "content-type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axios.post(CHECKOUT, payload, config);
    return response;
  } catch (error) {
    return error.response;
  }
};
